import React from 'react'
import SubAdmin from '../masterLayout/SubAdmin'
import Breadcrumb from '../components/Breadcrumb'
import ManagerLoanDetails from '../components/child/ManagerLoanDetails'

const StucredSubAdmin = () => {
  return (
        <SubAdmin>
        <Breadcrumb title="Loan Details" />
        <ManagerLoanDetails />


    </SubAdmin>
  )
}

export default StucredSubAdmin